import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "slc--panel slc--panel__output",
  key: "outputs"
}
const _hoisted_2 = { class: "slc--column" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "slc--label__header slc--label__tight slc--left" }, "Average Gallons of Fuel Dropped Per Stop", -1 /* HOISTED */)
const _hoisted_4 = { class: "slc--column-container slc--column-container__outputs" }
const _hoisted_5 = { class: "slc--column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "slc--label slc--label__tight" }, "SmartLid", -1 /* HOISTED */)
const _hoisted_7 = {
  class: "slc--text-output",
  id: "smartLidOutput"
}
const _hoisted_8 = { class: "slc--column" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "slc--label slc--label__tight" }, "Standard Lid", -1 /* HOISTED */)
const _hoisted_10 = {
  class: "slc--text-output",
  id: "standardLidOutput"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "slc--label__header slc--label__tight slc--left" }, "Annual Savings", -1 /* HOISTED */)
const _hoisted_12 = { class: "slc--column-container slc--column-container__outputs" }
const _hoisted_13 = { class: "slc--column" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "slc--label slc--label__tight slc--label__has-message" }, [
  /*#__PURE__*/_createTextVNode("Cost Savings "),
  /*#__PURE__*/_createElementVNode("div", { class: "slc--message slc--message__information" }, "The estimated total cost saved on all monitored accounts per year.")
], -1 /* HOISTED */)
const _hoisted_15 = {
  class: "slc--text-output",
  id: "costSavingsOutput"
}
const _hoisted_16 = { class: "slc--column" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "slc--label slc--label__tight slc--label__has-message" }, [
  /*#__PURE__*/_createTextVNode("Trip Savings "),
  /*#__PURE__*/_createElementVNode("div", { class: "slc--message slc--message__information" }, "The estimated number of technical/bobtail stops elmininated using SmartLid.")
], -1 /* HOISTED */)
const _hoisted_18 = {
  class: "slc--text-output",
  id: "tripSavingsOutput"
}
const _hoisted_19 = { class: "slc--column" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "slc--label slc--label__tight slc--label__has-message" }, [
  /*#__PURE__*/_createTextVNode("Savings per Customer "),
  /*#__PURE__*/_createElementVNode("div", { class: "slc--message slc--message__information" }, "The estimated total amount saved per customer per year.")
], -1 /* HOISTED */)
const _hoisted_21 = {
  class: "slc--text-output",
  id: "savingsPerCustomerOutput"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { class: "slc--label__header slc--label__tight slc--left" }, [
  /*#__PURE__*/_createTextVNode("Long-Term Savings "),
  /*#__PURE__*/_createElementVNode("small", null, "Monitor and fees included")
], -1 /* HOISTED */)
const _hoisted_23 = { class: "slc--column-container slc--column-container__outputs" }
const _hoisted_24 = { class: "slc--column" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "slc--label slc--label__tight" }, "5 Years", -1 /* HOISTED */)
const _hoisted_26 = {
  class: "slc--text-output",
  id: "fiveYearsOutput"
}
const _hoisted_27 = { class: "slc--column" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "slc--label slc--label__tight" }, "10 Years", -1 /* HOISTED */)
const _hoisted_29 = {
  class: "slc--text-output",
  id: "tenYearsOutput"
}
const _hoisted_30 = { class: "slc--column" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "slc--label slc--label__tight" }, "15 Years", -1 /* HOISTED */)
const _hoisted_32 = {
  class: "slc--text-output",
  id: "fifteenYearsOutput"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  class: "slc--panel slc--panel__input",
  key: "inputs"
}
const _hoisted_35 = { class: "slc--error slc--center" }
const _hoisted_36 = { class: "slc--column-container slc--column-container__input-groups" }
const _hoisted_37 = { class: "slc--column" }
const _hoisted_38 = { class: "slc--input-group" }
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div class=\"slc--column-container slc--column-container__default\"><div class=\"slc--column\"><img src=\"/ResourcePackages/Worthington/assets/dist/images/smartlid/slc-tank.png\" alt=\"42# Tank\"></div><div class=\"slc--column slc--right\"><img src=\"/ResourcePackages/Worthington/assets/dist/images/smartlid/slc-smartlid-vertical-horizontal.png\" alt=\"SmartLid Tanks\"></div></div><label class=\"kicker\">Number of Customers</label>", 2)
const _hoisted_41 = { class: "slc--input slc--input__range" }
const _hoisted_42 = {
  class: "slc--range-handle",
  ref: "handle"
}
const _hoisted_43 = { class: "slc--error" }
const _hoisted_44 = { class: "slc--input-group slc--input-group__columns" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "slc--label" }, "Number of Tanks per Customer", -1 /* HOISTED */)
const _hoisted_46 = { class: "slc--input" }
const _hoisted_47 = { class: "slc--error" }
const _hoisted_48 = { class: "slc--input-group slc--input-group__columns" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "slc--label" }, "Tank Size", -1 /* HOISTED */)
const _hoisted_50 = { class: "slc--input slc--input__select" }
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<option value=\"47.2\">200-pound</option><option value=\"96\">420-pound</option><option value=\"200\">250 Gallon</option><option value=\"256\">320 Gallon</option><option value=\"400\">500 Gallon</option><option value=\"800\">1000 Gallon</option>", 6)
const _hoisted_57 = [
  _hoisted_51
]
const _hoisted_58 = { class: "slc--error" }
const _hoisted_59 = { class: "slc--input-group slc--input-group__columns" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "slc--label" }, "Cost Per Refill Stop", -1 /* HOISTED */)
const _hoisted_61 = { class: "slc--input" }
const _hoisted_62 = { class: "slc--error" }
const _hoisted_63 = { class: "slc--column" }
const _hoisted_64 = { class: "slc--input-group" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "slc--column-container slc--column-container__default" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "slc--column slc--center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/ResourcePackages/Worthington/assets/dist/images/smartlid/slc-truck.png",
      alt: "Tank Truck"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "kicker" }, "Average Gallons a Year per Customer", -1 /* HOISTED */)
const _hoisted_67 = { class: "slc--input slc--input__range" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "slc--range-handle" }, null, -1 /* HOISTED */)
const _hoisted_69 = { class: "slc--error" }
const _hoisted_70 = { class: "slc--input-group slc--input-group__columns" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "slc--label" }, "Average Level at Refill", -1 /* HOISTED */)
const _hoisted_72 = { class: "slc--input slc--input__select" }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "slc--error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.smartlidGallonsFilledPerStop), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.traditionalGallonsFilledPerStop), 1 /* TEXT */)
          ])
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.annualSavings), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.tripsSavedPerYear), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.annualSavingsPerCustomer), 1 /* TEXT */)
          ])
        ]),
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.fiveYearSavings), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.tenYearSavings), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.fifteenYearSavings), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", {
          class: "slc--message slc--message__results",
          innerHTML: _ctx.resultsMessage
        }, null, 8 /* PROPS */, _hoisted_33),
        _createElementVNode("button", {
          class: "slc--button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.reset && $options.reset(...args)))
        }, "Reset Calculator")
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.validationPassed]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.errorGeneric), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_41, [
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "slc--range",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.numberOfCustomers) = $event)),
                onInput: _cache[2] || (_cache[2] = ($event: any) => ($options.setSlider($event,'numberOfCustomers'))),
                onChange: _cache[3] || (_cache[3] = ($event: any) => ($options.setSlider($event,'numberOfCustomers'))),
                min: "1",
                max: "20000",
                step: "1"
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.numberOfCustomers]
              ]),
              _createElementVNode("div", _hoisted_42, null, 512 /* NEED_PATCH */),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "slc--range-output",
                ref: "handleInput",
                onFocus: _cache[4] || (_cache[4] = ($event: any) => ($options.setSlider2($event,'numberOfCustomers',true))),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.numberOfCustomers2) = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => ($options.validateNumberOfCustomers($event))),
                onInput: _cache[7] || (_cache[7] = ($event: any) => ($options.validateNumberOfCustomers($event))),
                min: "1",
                max: "20000",
                maxlength: "6"
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.numberOfCustomers2]
              ])
            ]),
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.errorNumberOfCustomers), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                maxlength: "5",
                class: "slc--input-group--quantity",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tanksPerCustomer) = $event)),
                onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($options.validateTanksPerCustomer && $options.validateTanksPerCustomer(...args)))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.tanksPerCustomer]
              ])
            ]),
            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.errorTanks), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tankSize) = $event))
              }, _hoisted_57, 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.tankSize]
              ])
            ]),
            _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.errorTankSize), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "$",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.costPerRefillStop) = $event)),
                onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($options.validateCostPerRefillStop && $options.validateCostPerRefillStop(...args)))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.costPerRefillStop]
              ]),
              _createCommentVNode(" Input changed from type number to type text to account for required dollar sign ")
            ]),
            _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.errorStopCost), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "slc--range",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.gallonsPerYearPerCustomer) = $event)),
                onInput: _cache[14] || (_cache[14] = ($event: any) => ($options.setSlider($event,'gallonsPerYearPerCustomer'))),
                onChange: _cache[15] || (_cache[15] = ($event: any) => ($options.setSlider($event,'gallonsPerYearPerCustomer'))),
                step: "1",
                min: "1",
                max: "500000"
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.gallonsPerYearPerCustomer]
              ]),
              _hoisted_68,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "slc--range-output",
                onFocus: _cache[16] || (_cache[16] = ($event: any) => ($options.setSlider2($event,'gallonsPerYearPerCustomer',true))),
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.gallonsPerYearPerCustomer2) = $event)),
                onChange: _cache[18] || (_cache[18] = ($event: any) => ($options.validateAverageGallons($event))),
                onInput: _cache[19] || (_cache[19] = ($event: any) => ($options.validateAverageGallons($event))),
                min: "1",
                max: "500000",
                maxlength: "7"
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.gallonsPerYearPerCustomer2]
              ])
            ]),
            _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.errorGallonsPerYearPerCustomer), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.avergeLevelAtRefill) = $event))
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(99, (index) => {
                  return _createElementVNode("option", {
                    key: index,
                    value: index
                  }, _toDisplayString(index) + "%", 9 /* TEXT, PROPS */, _hoisted_73)
                }), 64 /* STABLE_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.avergeLevelAtRefill]
              ])
            ]),
            _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.errorLevel), 1 /* TEXT */)
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "slc--button",
          onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => ($options.validate && $options.validate(...args)))
        }, "Calculate")
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.validationPassed]
    ])
  ]))
}